module.exports = __webpack_public_path__ + "static/img/img-bg-about-us.c1f67e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-bg-about-us.png
// module id = qHGV
// module chunks = 36